import { lazy } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import { getSampleViewSelection, getSampleViewUrl } from '../utils/url';

const BinocularsPage = lazy(() => import('../pages/BinocularsPage.tsx'));

export default function DefaultEvalViewer() {
  const { evalSetId = '' } = useParams();
  const location = useLocation();
  // Inspect still supports combined eval sets and event-level timelines.
  if (evalSetId.includes(',') || /\/transcript\?/.test(location.hash)) {
    return (
      <Navigate
        replace
        to={{
          ...location,
          pathname: `/eval-set/${encodeURIComponent(evalSetId)}/inspect`,
        }}
      />
    );
  }
  const legacySelection = getSampleViewSelection('', location.hash);
  if (legacySelection) {
    return (
      <Navigate
        replace
        to={getSampleViewUrl({
          evalSetId,
          ...legacySelection,
          anchor: legacySelection.messageId
            ? {
                tab: 'messages',
                param: 'message',
                value: legacySelection.messageId,
              }
            : undefined,
        })}
      />
    );
  }
  if (/^#\/(?:logs|samples|tasks)\/.+/.test(location.hash)) {
    return (
      <Navigate
        replace
        to={{
          ...location,
          pathname: `/eval-set/${encodeURIComponent(evalSetId)}/inspect`,
        }}
      />
    );
  }
  return <BinocularsPage key={evalSetId} />;
}
